<script>
import { h } from 'vue'

function split(type, _str) {
	const str = _str?.toString() ?? ''
	const splitter = { lines: /\n/g, words: / |\n/g, chars: '' }

	const fragments = type === 'none' ? [str] : str.split(splitter[type] || '')

	if (type === 'words') {
		return fragments.map((f, index) => (index < fragments.length - 1 ? f + ' ' : f))
	}

	if (type === 'chars') {
		return fragments.map((f) => f.replace(/\n/g, ' '))
	}

	return fragments
}

const INTERNAL_CLASSNAMES = {
	line: 'l',
	word: 'w',
	char: 'c',
	fragment: 'f',
}

export default {
	props: {
		as: { type: String, default: 'span' },
		text: { type: [Number, String], required: true },
		words: { type: Boolean, default: false },
		lines: { type: Boolean, default: false },
		chars: { type: Boolean, default: false },
		classnames: { type: [String, Object], default: () => ({}) },
		clientOnly: { type: Boolean, default: false },

		// WIP:
		inferLines: { type: Boolean, default: true }, // infer lines from DOM size
	},
	mounted() {
		if (this.clientOnly) {
			this.$forceUpdate()
		}
	},
	render() {
		const { $props } = this
		const splits = Object.fromEntries(['lines', 'words', 'chars'].map((key) => [key, $props[key] ? key : 'none']))

		let slot = $props.text

		function resolvePropClassname(type) {
			if ($props.classnames === 'motion') {
				return type === 'fragment' ? 'm-t' : 'm-c'
			} else if (Object.hasOwn($props.classnames, type)) {
				return $props.classnames[type]
			}

			return undefined
		}

		// https://github.com/egoist/vue-client-only/blob/master/src/index.js
		if (!$props.clientOnly || this.$?.isMounted) {
			function renderComponent(type, children, isLastComponent = false) {
				const defaultClassname = INTERNAL_CLASSNAMES[type] || []
				const propClassname = resolvePropClassname(type) || []
				let classnames = [defaultClassname, propClassname].flat().join(' ')

				if (isLastComponent) {
					classnames += ' -last'
				}

				return h(type === 'line' ? 'div' : 'span', { class: classnames }, children)
			}

			const lines = split(splits.lines, $props.text).map((line, lineIndex, _lines) => {
				const words = split(splits.words, line).map((word, wordIndex, _words) => {
					const chars = split(splits.chars, word).map((char, charIndex, _chars) => {
						return renderComponent('char', [renderComponent('fragment', char, lineIndex === _lines.length - 1 && wordIndex === _words.length - 1 && charIndex === _chars.length - 1)])
					})
					return renderComponent('word', $props.chars ? chars : chars[0].children)
				})
				return renderComponent('line', $props.words ? words : words[0].children)
			})

			slot = $props.lines ? lines : lines[0].children
		}

		return h($props.as, { 'data-split-text': '' }, slot)
	},
}
</script>

<style lang="scss">
[data-split-text] {
	$letter-spacing: var(--letter-spacing, -0.01em);

	text-indent: 0;
	white-space: pre-wrap;

	.w {
		display: inline-block;
	}

	.w:not(:first-child),
	.w:not(:first-child) {
		text-indent: 0;
	}

	.c {
		display: inline-block;
		margin-left: $letter-spacing;

		&:first-child {
			margin-left: 0;
		}
	}

	.w,
	.c {
		will-change: transform;
	}

	.-last {
		padding-right: 0.06em;
	}
}
</style>
